.radioBox label:nth-child(1) {
  font-size: 14px;
  user-select: none;
}

.inputWatchlistContainer input {
  caret-color: transparent !important;
  cursor: pointer !important;
}

.inputWatchlistContainer input::placeholder {
  opacity: 1;
  color: var(--mantine-color-primary-7);
}

.actionDeleteIcons:not(:disabled) {
  background-color: light-dark(var(--mantine-color-danger-1), var(--mantine-color-primaryDark-7));
}

.actionIcons:hover:not(:disabled) {
  background-color: light-dark(var(--mantine-color-primary-2), var(--mantine-color-primaryDark-6));
}

.actionDeleteIcons:hover:not(:disabled) {
  background-color: light-dark(var(--mantine-color-danger-2), var(--mantine-color-primaryDark-6));
}

.groupBG {
  border-radius: var(--mantine-radius-sm);
}

.groupBG:hover {
  background-color: light-dark(var(--mantine-color-primary-0), var(--mantine-color-primaryDark-7));
  border-color: light-dark(var(--mantine-color-primary-6), var(--mantine-color-secondary-5)) !important;
}

/* Dark mode */
[data-mantine-color-scheme='dark'] .inputWatchlistContainer input::placeholder {
  color: var(--mantine-color-primary-0);
}

[data-mantine-color-scheme='dark'] .modalTitle h2 {
  color: var(--mantine-color-primaryDark-1) !important;
}
